<div [ngClass]="{'mox-ui-page-container': claim.isMox()}">
    <div class="prev-bar">
      <a (click)="back()" style="color: #0064c1" class="btn new-btn btn-secondary"><i class="fas fa-arrow-left"></i>&nbsp;{{ 'claimSection.generalLabels.generalButtonLabels.back' | translate}}&nbsp;</a>
      <a (click)="back()" *ngIf="claim.isMox()" class="back-chevron"></a>
    </div>
    <div class="col-12">
      <h5>{{ 'homeProduct.common.tellUsWhatHappened' | translate }}</h5>
      <p>{{ 'homeProduct.common.detailsOfTheIncident' | translate}}</p>
    </div>
    <BR>
    <div class="row col-12">
      <div [ngClass]="claim.isMox() ? 'col-lg-12 col-md-12' : 'col-lg-9 col-md-12'">
  
        <form>
          <div>
            <div class="form-group">
              <qnect-ui #HOME_WEATHER_TYPEOFWEATHER [fieldId]="'HOME_WEATHER_TYPEOFWEATHER'" [formGroup]="weatherForm" name="typeOfWeather"></qnect-ui>
            </div>
            <div class="form-group" *ngIf="this.homeDetails.getWeather().getTypeOfWeather() =='Others'">
              <qnect-ui #HOME_WEATHER_TYPEOFWEATHER_OTHERS [fieldId]="'HOME_WEATHER_TYPEOFWEATHER_OTHERS'" [formGroup]="weatherForm" name="typeOfWeatherOthers"></qnect-ui>
            </div>
            <div class="form-group">
              <qnect-ui #HOME_WEATHER_ISTHEPROPERTYSAFETOSTAYIN [fieldId]="'HOME_WEATHER_ISTHEPROPERTYSAFETOSTAYIN'" [formGroup]="weatherForm" name="isThePropertySafeToStayIn"></qnect-ui>
            </div>
            <ng-container *ngIf="this.homeDetails.getIsThePropertySafeToStayIn()==false">
              <div class="form-group">
                <label [innerHTML]="'homeProduct.common.pleaseContact' | translate"></label>
              </div>
              <!-- <div class="form-group">
                <label [innerHTML]="'homeProduct.common.or' | translate"></label>
              </div>
              <div class="form-group">
                <qnect-ui #HOME_APPOINTBUILDER [fieldId]="'HOME_APPOINTBUILDER'" [formGroup]="weatherForm" name="isAppointBuilder"></qnect-ui>
              </div>  -->
              <div class="form-group">
                <label [innerHTML]="'homeProduct.common.or' | translate"></label>
              </div> 
              <div class="form-group">
                <label [innerHTML]="'homeProduct.common.emergencyHotline' | translate"></label>
              </div>
            </ng-container>
            <ng-container *ngIf="this.claim.getCountry().toLowerCase() == 'hgi'">
              <div class="form-group" *ngIf="this.claimHome.getIsContentPremClassExist()">
                <qnect-ui #HOME_CONTENTSBUILDING_ISTHEREINTERIORDAMAGE [fieldId]="'HOME_CONTENTSBUILDING_ISTHEREINTERIORDAMAGE'" [formGroup]="weatherForm" name="isThereInteriorDamage"></qnect-ui>
              </div>
              <div class="form-group" *ngIf="this.claimHome.getHasFixFitFlag()">
                <qnect-ui #HOME_CONTENTSBUILDING_ISTHEREFIXTURESDAMAGE [fieldId]="'HOME_CONTENTSBUILDING_ISTHEREFIXTURESDAMAGE'" [formGroup]="weatherForm" name="isThereFixturesDamage"></qnect-ui>
              </div>
            </ng-container>
            <ng-container *ngIf="this.claimHome.getIsBuildingPremClassExist()">
              <div class="form-group">
                <qnect-ui #HOME_CONTENTSBUILDING_ISTHEREWINDOWDAMAGE [fieldId]="'HOME_CONTENTSBUILDING_ISTHEREWINDOWDAMAGE'" [formGroup]="weatherForm" name="isThereWindowDamage"></qnect-ui>
              </div>
              <div class="form-group">
                <qnect-ui #HOME_CONTENTSBUILDING_ISTHERESERIOUSDAMAGE [fieldId]="'HOME_CONTENTSBUILDING_ISTHERESERIOUSDAMAGE'" [formGroup]="weatherForm" name="isThereSeriousDamage"></qnect-ui>
              </div>
            </ng-container>
            <ng-container *ngIf="this.homeDetails.getIsThereSeriousDamage() || this.homeDetails.getIsThereInteriorDamage() || this.homeDetails.getIsThereFixturesDamage()">
              <div class="form-group">
                <qnect-ui #HOME_CONTENTSBUILDING_DAMAGEDESCRIPTION [fieldId]="'HOME_CONTENTSBUILDING_DAMAGEDESCRIPTION'" [formGroup]="weatherForm" name="damageDescription"></qnect-ui>
              </div>
              <div class="form-group" *ngIf="!isMoxPackageCode">
                <qnect-ui #HOME_ASSISTBUILDER [fieldId]="'HOME_ASSISTBUILDER'" [formGroup]="weatherForm" name="isAssistBuilder"></qnect-ui>
              </div>
              <div  *ngIf="claim.getClaimHome().getHomeDetails().getIsAssistBuilder()" class="form-group">
                <div class="dept-del-info col-xl-8 col-xs-12 col-md-8">
                  <div class="row col-12 col-md-12">
                    <div class="col-3 col-md-2" style="padding: 5px;">
                      <img src="assets/images/builder.png" id="ray-travel-delay">
                  </div>
                    <div class=" col-9 col-md-10 dept-desc-text">{{ 'homeProduct.contentsBuilding.adjusterwillContact' | translate}}</div>
                  </div>
                </div>
              </div>
              <br/>
            </ng-container>
            <div class="form-group" *ngIf="this.claimHome.getIsContentPremClassExist()">
              <qnect-ui #HOME_CONTENTSBUILDING_ISANYITEMDAMAGED [fieldId]="'HOME_CONTENTSBUILDING_ISANYITEMDAMAGED'" [formGroup]="weatherForm" name="isAnyItemDamaged"></qnect-ui>
            </div>
          </div>
        </form>
  
      </div>
      <div [ngClass]="claim.isMox() ? 'd-none' : 'col-lg-3 col-xl-3 col-md-12'">
        &nbsp;
      </div>
    </div>
    <div class="submit-bar">
      <abandon-button></abandon-button>
      <a href="javascript:;" (click)="showModal()" class="Tertiary" [hidden]="claim.isMox()"> {{ 'claimSection.generalLabels.generalButtonLabels.save' | translate}}</a>
      <button (click)="goToNext()" class="btn new-btn btn-primary float-right">&nbsp;{{ 'claimSection.generalLabels.generalButtonLabels.next' | translate}}&nbsp;<i class="fas fa-arrow-right" ></i></button>
    </div>
    <app-save-box [showTotalBox]="showTotalBox" (childEvent)="getData($event)"></app-save-box>
  </div>
  